var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tooltip-button',{attrs:{"icon":"","dark":"","position":"bottom","icon-name":_vm.$root.appIcons.return,"data-text":"Back","color":"secondary"},on:{"click":function($event){return _vm.$router.back()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }